// Threshold for when scrollbar is typically visible in dropdowns
// Use this to show the search input in dropdowns
export const DEFAULT_SHOW_SEARCH_THRESHOLD = 8;
